import React from "react";
import { getGlobalValue } from "@rea-argonaut/global-store";
var defaultContext = {
  addToast: () => {},
  removeToast: () => {}
};
export default getGlobalValue({
  key: "ToastContext",
  moduleName: "@rea-group/construct-kit-core",
  createValue: () => /*#__PURE__*/React.createContext(defaultContext)
});